import {Component, ElementRef, ViewChild} from "@angular/core";
import {ModalService} from "../services/modal.service";
import {AppMessage} from "../definitions";
import {APP_MESSAGES} from "../enums/enums";
import {CollectionService} from "../services/collection.service";
import {Subject} from "rxjs/Subject";
import {NavigationState} from "../helpers/navigation-state";
import {SearchController} from "../helpers/search-controller";
import {CollectionParams} from "../helpers/params/collection-params";
import {paramsHelper} from "../helpers/params-helper";
import {IDocument} from "../interfaces/document.definition";

declare const $: any;


@Component({
  selector: "nv-modal-select",
  templateUrl: "./select-modal.component.html"
})


export class SelectModalComponent {
  collectionParams: CollectionParams;
  subject: Subject<IDocument>;
  list: IDocument[];
  nav: NavigationState;
  searchController: SearchController;

  @ViewChild("selectModal") element: ElementRef;


  constructor(private modalService: ModalService,
              private collectionService: CollectionService) {
    this.nav = new NavigationState(() => this.loadList());
    this.searchController = new SearchController(() => this.loadList());

    this.modalService.onModalRequest
      .subscribe((appMessage): void => this.handleMessage(appMessage));
  }


  onSelectClick(item: IDocument) {
    $(this.element.nativeElement).modal("hide");
    this.subject.next(item);

    // todo: onDestroy - delete subject!
  }


  private loadList() {
    const params = paramsHelper.loader()
      .setEndpointApi()
      .setObjectType(this.collectionParams.getObjectType())
      .setNavParams(this.nav.offset, this.nav.limit)
      .setSearchParams(this.searchController.collectSearchParams());

    this.collectionService
      .loadChunk(params)
      .subscribe(
        r => {
          this.list = r.documents;
          this.nav.update(r.offset, r.count);
        });
  }


  private handleMessage(appMessage: AppMessage) {
    switch (appMessage.type) {
      case APP_MESSAGES.POPUP_QUERY__SELECT:
        this.select(appMessage.content);
        break;

    }
  }


  private select(data: any) {
    this.collectionParams = data.collectionParams;
    this.searchController.setParams(this.collectionParams.getSearchParams(), this.collectionParams.getFilterParams());
    this.subject = data.subject;

    this.loadList();
    $(this.element.nativeElement).modal("show");
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/select-modal.component.ts